/* eslint-disable class-methods-use-this */
import React from 'react';
import PriceMatrixCell from 'pu-react/components/PriceMatrixCell';
import { START } from 'pu-data/QuoteSteps'
import { getClassName } from './PriceMatrixHead';

class PriceMatrixCellMx extends PriceMatrixCell {
  cellClass() {
    return getClassName(this.props.leadTime)
  }

  renderEmpty() {
    return '';
  }

  render() {
    const total = this.totalPrice();
    let field;
    if (total == null) {
      field = this.renderEmpty();
    } else if (this.props.quoteStep === START) {
      field = this.renderInput();
    } else if (total > 0) {
      field = this.renderInput();
    } else {
      field = this.renderEmpty();
    }
    return <td className={this.cellClass()}>{field}</td>;
  }
}

export default PriceMatrixCellMx;
